module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-raise-the-bar-oudenaarde-nutrition-coach-thumbnail.659e752e.png";